import RRS from 'constants/recurrence/recurrenceRuleSimplified.const';
import C from 'utils/values/constant.util';

const TIME_OFF_REPEAT = C({
  [RRS.onlyOnce]: { id: RRS.onlyOnce, description: 'No repeat' },
  [RRS.every1Day]: { id: RRS.every1Day, description: 'Daily' },
  [RRS.every1Week]: { id: RRS.every1Week, description: 'Weekly' },
  [RRS.every2Weeks]: { id: RRS.every2Weeks, description: 'Every 2 weeks' },
  [RRS.every3Weeks]: { id: RRS.every3Weeks, description: 'Every 3 weeks' },
  [RRS.every4Weeks]: { id: RRS.every4Weeks, description: 'Every 4 weeks' },
});

export default TIME_OFF_REPEAT;
